import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton } from '@mui/material';
import { Close, UploadFile } from '@mui/icons-material';

import { uploadCurrentEmployeeNotice } from '../../../../actions/employeesActions';
import { getSignedFileUrl } from '../../../../actions/utilsActions';

const styles = {
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  item: {
    my: '0.5rem'
  },
  divider: {
    py: '0.5rem'
  }
}

const EmployeeDetailsNoticeDialog = props => {
  const [file, setFile] = useState(null);
  const [signedUrls, setSignedUrls] = useState({});

  const dispatch = useDispatch();

  const handleFileChange = e => setFile(e.target.files[0]);

  useEffect(() => {
    const fetchSignedUrls = async () => {
      if (!props.notices || props.notices.length === 0) return;
  
      const urls = {};
      for (const notice of props.notices) {
        try {
          const signedUrl = await dispatch(getSignedFileUrl({ query: notice })).unwrap();
          urls[notice] = signedUrl;
        } catch (err) {
          console.error('Error getting signed URL for', notice, err);
        }
      }
      setSignedUrls(urls);
    };
  
    fetchSignedUrls();
  }, [props.notices, dispatch]);
  
  const handleClose = () => {
    setFile(null);
    props.onClose();
  }

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(uploadCurrentEmployeeNotice({ id: props.id, notice: file }));
    props.onClose();
  }

  return (
    <Dialog open={props.open} onClose={handleClose} maxWidth={false}>
      <DialogTitle sx={styles.title}>
        Acuerdos de tratamiento de datos personales
        <IconButton onClick={handleClose}><Close /></IconButton>
      </DialogTitle>
      <DialogContent sx={styles.content}>
        {props.notices.map(notice =>
          <Box key={notice} sx={styles.item}>
            {signedUrls[notice] ? (
              <a href={signedUrls[notice]} target="_blank" rel="noreferrer">
                Acuerdo {notice.split('/').pop()}
              </a>
            ) : (
              'Cargando enlace…'
            )}
            <Divider sx={styles.divider} />
          </Box>  
        )}
      </DialogContent>
      <DialogActions>
        <IconButton component="label">
          <UploadFile /><input type="file" hidden={true} accept="application/pdf" onChange={handleFileChange} />
        </IconButton>
        <Button variant="text" disabled={!file} onClick={handleSubmit}>Guardar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default EmployeeDetailsNoticeDialog;
